<template>
  <div class="newsletter-category-wrap">
      <p>
          Choose which newsletter categories you want to subscribe to.
      </p>
      <div class="newsletter-categories">
            <div v-for="category in categories" :key="category.title" class="newsletter-category-entry">
                <div class="category-checkbox">
                    <input type="checkbox" :id="category.title" v-model="category.is_enabled" />
                    <label :for="category.title">{{ formatCategoryTitle(category.title) }}</label>
                </div>
                <div class="category-description">{{ category.description }}</div>
            </div>
        </div>
      <div class="newsletter-update">
        <ModalMessage :message="feedbackMessage" :type="feedbackType" />
        <a class="fa-btn fa-btn-primary fa-btn-modal" @click="updateSettings">Update settings</a>
      </div>
  </div>
</template>


<script setup>
import { ref, onMounted, computed, onBeforeMount, onUnmounted } from 'vue';
import APIClient from '/api/apiClient.ts';
import { useUIStore } from '@/store/uiStore';
import { ModalTypes, MessageType } from '@/types/enums';
import { CSRFType } from '@/api/apiClient';
import CSRFManager from '~/utils/csrfManager.ts';

const csrfManager = new CSRFManager(CSRFType.UPDATE_NEWSLETTER_SETTINGS);
const csrfToken = computed(() => csrfManager.state.csrfToken);

onBeforeMount(async () => {
  await csrfManager.startFetchingToken();
});

onUnmounted(() => {
  csrfManager.stopFetchingToken();
});

const uiStore = useUIStore();
const apiClient = APIClient.getInstance();
const categories = ref([]);
const feedbackMessage = ref(''); // Placeholder for dynamic messages.
const feedbackType = ref(MessageType.INFO);

onMounted(async () => {
  const response = await apiClient.fetchNewsletterSettings();
  if (response && response.valid) {
    categories.value = response.result.options;
  }
  csrfManager.fetchToken();
});

const updateSettings = async () => {
  feedbackMessage.value = 'Updating settings...';
  feedbackType.value = MessageType.INFO;

  const selectedOptionsValue = categories.value
    .filter(cat => cat.is_enabled)
    .reduce((acc, cat) => acc + cat.value, 0);

  const response = await apiClient.updateNewsletterSettings(selectedOptionsValue, csrfToken.value);
  console.log(response, "updateNewsletter response");
  if (response && response.result.value === selectedOptionsValue) {
    feedbackMessage.value = 'Settings have been updated successfully.';    
    feedbackType.value = MessageType.SUCCESS;
    uiStore.setModalType(ModalTypes.INACTIVE);
  } else {
    feedbackMessage.value = 'There was an error updating your settings. Please try again.';
    feedbackType.value = MessageType.ERROR;
  }
  csrfManager.fetchToken();

};
const formatCategoryTitle = (title) => {
    if (title === 'videos & tutorials basic') {
        return 'Videos & Tutorials (Basic)';
    }
    if (title === 'videos & tutorials pro') {
        return 'Videos & Tutorials (Pro)';
    }

    // Split the string by space, capitalize each word, and then join them back together
    return title.split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
}

</script>

<style lang="scss" scoped>
@import '~/assets/constants.scss';

.newsletter-categories {
    display: flex;
    flex-direction: column;

    .newsletter-category-entry {
        display: flex;
        align-items: center; // to vertically center the checkbox and its label
        padding: 0.5rem 0; // some vertical padding for spacing between rows

        .category-checkbox {
            display: flex;
            align-items: center; // to vertically center the checkbox and its label
            min-width: 250px; // Adjust this based on your preferred width or the largest title
            
            input[type="checkbox"] {
                margin-right: 10px; // some space between checkbox and label
            }
        }

        .category-description {
            flex-grow: 1; // to take the remaining space
            font-size: 1rem;
            color: $fa-gray;
        }
    }
}

</style>
